import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SwiperNav, { type PageKey } from "@/components/SwiperNav";
import TitleBlock from "@/components/TitleBlock";
import WorkSection from "@/components/WorkSection";
import MethodSection from "@/components/MethodSection";
import AboutSection from "@/components/AboutSection";
import HeroAscii from "@/components/ui/hero-ascii";

const pageVariants = {
  initial: { y: "100%", opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: "-20%", opacity: 0 },
};

const pageTransition = {
  duration: 0.5,
  ease: [0.22, 1, 0.36, 1] as const,
};

const Index = () => {
  const [currentPage, setCurrentPage] = useState<PageKey>("home");

  return (
    <div className="bg-background text-foreground h-screen w-screen overflow-hidden relative">
      {/* Persistent background layer */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 grain" />
        <div className="absolute inset-0 opacity-60">
          <HeroAscii />
        </div>
      </div>

      {/* Navigation */}
      <SwiperNav currentPage={currentPage} onNavigate={setCurrentPage} />

      {/* Page content with transitions */}
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPage}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={pageTransition}
          className="absolute inset-0 z-10 pt-14"
        >
          {currentPage === "home" && <TitleBlock />}
          {currentPage === "work" && <WorkSection />}
          {currentPage === "method" && <MethodSection />}
          {currentPage === "about" && <AboutSection />}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Index;
